import {
    Page,
    Button,
    Card,
    Text,
    Layout,
    FormLayout,
    TextField, Checkbox, Divider, Select, LegacyStack, RadioButton, ContextualSaveBar, Banner
} from "@shopify/polaris";
import React, {useEffect, useState} from "react";
import {Redirect} from "@shopify/app-bridge/actions";
import Http from "../Lib/Http";
import {useForm} from "../Lib/Form";
import {ChartIcon, ResponseErrors, Settings} from "../types";
import Alert from "../Lib/Alert";
import {ColorResult, SketchPicker} from "react-color";
import Menu from "@admin/Lib/Menu";
import CriticalError from "@admin/components/CriticalError";

function Design() {
    const [baseURL, setBaseURL] = useState<string | null>(null);
    const [imageUrl, setImageURL] = useState<string | null>(null);
    const [selectedSvg, setSelectedSvg] = useState<ChartIcon | null>(null);
    const [loading, setLoading] = useState(false);
    const [showTriggerColorPicker, setShowTriggerColorPicker] = useState(false);
    const [showHeaderBorderColorPicker, setShowHeaderBorderColorPicker] = useState(false);
    const [showHeaderTextColorPicker, setShowHeaderTextColorPicker] = useState(false);
    const [showHeaderBackgroundColorPicker, setShowHeaderBackgroundColorPicker] = useState(false);
    const [showBodyBorderColorPicker, setShowBodyBorderColorPicker] = useState(false);
    const [showBodyTextColorPicker, setShowBodyTextColorPicker] = useState(false);
    const [showBodyBackgroundColorPicker, setShowBodyBackgroundColorPicker] = useState(false);
    const [formInitialized, setFormInitialized] = useState<boolean>(false);
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const [showBilling, setShowBilling] = useState(true);
    const [error, setError] = useState(false);
    const [legacy, setLegacy] = useState<number>(1);
    const [free, setFree] = useState<number>(0);
    const form = useForm<Settings>({
        tableBodyEditable: false,
        btnTextEditable: false,
        displayEditable: false,
        displayOption: 'link',
        collapseBorder: false,
        color: "#000000",
        customCss: "",
        bodyFont: '',
        bodyFontSize: '12',
        bodyBorderColor:  "#494949",
        bodyBorderWidth:  '1',
        bodyTextColor:  "#000000",
        bodyBackgroundColor:  "#FFFFFF",
        tableHeaderEditable: false,
        allowUnitConversion: false,
        headerFont: '',
        headerFontSize: '12',
        headerBorderColor:  "#494949",
        headerBorderWidth:  '1',
        headerTextColor:  "#000000",
        headerBackgroundColor:  "#FFFFFF",
        triggerEditable: false,
        triggerFont: '',
        tableAlignment: '',
        triggerFontSize: '12',
        triggerColor: "#000000",
        underlineTrigger: false,
        btnText:  "Size Guide",
        unit:  "CM",
        icon: null
    });

    const   svgs : ChartIcon[] = [
        { id: 1, name: 'SVG 1', content: '<svg   width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29 7.63a2.28 2.28 0 0 0-.79-1.58l-4.12-3.51a2.34 2.34 0 0 0-3.27.24l-2.21 2.57a1 1 0 1 0 1.52 1.3l2.21-2.56a.27.27 0 0 1 .21-.09.32.32 0 0 1 .23.08l4.07 3.5a.35.35 0 0 1 .11.22.34.34 0 0 1-.08.23l-1.1 1.27L24.27 8A1 1 0 0 0 23 9.49l1.52 1.31-.66.76-.76-.66a1 1 0 0 0-1.3 1.52l.76.65-.66.76-1.51-1.31A1 1 0 0 0 19 14l1.52 1.3-.66.76-.75-.65A1 1 0 1 0 17.84 17l.76.65-.65.76-1.52-1.3a1 1 0 1 0-1.3 1.51l1.51 1.31-.65.75-.76-.68a1 1 0 0 0-1.31 1.52l.76.65-.65.76-1.52-1.31a1 1 0 1 0-1.3 1.52l1.51 1.3-.65.76-.76-.65a1 1 0 1 0-1.31 1.5l.75.65L9.66 28a.3.3 0 0 1-.44 0l-4.07-3.5a.35.35 0 0 1-.15-.21.34.34 0 0 1 .08-.23L17.76 9.4a1 1 0 0 0-1.52-1.3L3.6 22.76a2.27 2.27 0 0 0-.55 1.68A2.3 2.3 0 0 0 3.84 26l4.07 3.51a2.35 2.35 0 0 0 1.51.56h.17a2.33 2.33 0 0 0 1.59-.79l11.54-13.4 5.68-6.57a2.27 2.27 0 0 0 .6-1.68z" style="fill:#231f20"/></svg>' },
        { id: 2, name: 'SVG 1', content: '<svg   width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="m62.707 17.293-16-16a1 1 0 0 0-1.414 0l-44 44a1 1 0 0 0 0 1.414l16 16a1 1 0 0 0 1.414 0l44-44a1 1 0 0 0 0-1.414zM3.414 46 6 43.414l1.293 1.293a1 1 0 0 0 1.414-1.414L7.414 42 9 40.414l1.293 1.293a1 1 0 0 0 1.414-1.414L10.414 39 12 37.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 36 15 34.414l1.293 1.293a1 1 0 0 0 1.414-1.414L16.414 33 18 31.414l1.293 1.293a1 1 0 0 0 1.414-1.414L19.414 30 21 28.414l1.293 1.293a1 1 0 0 0 1.414-1.414L22.414 27 24 25.414l1.293 1.293a1 1 0 0 0 1.414-1.414L25.414 24 27 22.414l1.293 1.293a1 1 0 0 0 1.414-1.414L28.414 21 30 19.414l1.293 1.293a1 1 0 0 0 1.414-1.414L31.414 18 33 16.414l1.293 1.293a1 1 0 0 0 1.414-1.414L34.414 15 36 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L37.414 12 39 10.414l1.293 1.293a1 1 0 0 0 1.414-1.414L40.414 9 42 7.414l1.293 1.293a1 1 0 0 0 1.414-1.414L43.414 6 46 3.414 50.086 7.5 7.5 50.086zM18 60.586 8.914 51.5 51.5 8.914 60.586 18z" style="fill:#1b1a1e"/><path d="M49.5 15.5a4 4 0 1 0 4 4 4.005 4.005 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2.002 2.002 0 0 1-2 2z" style="fill:#1b1a1e"/></svg>'},
        { id: 3, name: 'SVG 3', content: '<svg   width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><defs><style>.cls-1{fill:#d1e6e9}.cls-2{fill:#68c7d3}.cls-3{fill:#a1d8df}</style></defs><g id="Measuring_Tape" data-name="Measuring Tape"><path class="cls-1" d="M21 19c0 4.92-12.41 6.73-18 3-1.44-1-2.45-2.39-1.8-4C3.61 12.18 21 13 21 19z"/><path class="cls-2" d="M11 13h10v5H11z"/><path class="cls-1" d="M1 13h10v5H1z"/><ellipse class="cls-3" cx="11" cy="13" rx="10" ry="5"/><ellipse class="cls-2" cx="11" cy="13" rx="8" ry="3"/><path class="cls-3" d="M5.79 13a14.06 14.06 0 0 1 10.42 0 14.06 14.06 0 0 1-10.42 0z"/><path class="cls-1" d="M11 18h20v6H11z"/><path class="cls-2" d="M29 18h2v6h-2z"/><path class="cls-3" d="M25 20h2v4h-2zM21 22h2v2h-2zM17 20h2v4h-2zM13 22h2v2h-2zM9 20h2v4H9zM7 21.58v2A13.46 13.46 0 0 1 5 23v-2a13.46 13.46 0 0 0 2 .58z"/></g></svg>' },
        { id: 4, name: 'SVG 1', content: '<svg   width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" xml:space="preserve"><path fill="#18CEF6" d="M66.393 30.766c-.441-.293-10.173-8.012-10.173-8.012h-8.228c-1.275 3.171-3.891 6.048-7.931 6.048-3.893 0-6.657-2.877-7.932-6.048h-6.464s-8.243 6.161-9.01 6.8c-.735.613-.711 1.366-.245 2.23 0 0 1.91 3.121 2.302 3.734.08-.023 6.747-5.276 9.303-7.286v35.211H56.22V32.082c2.462 1.891 7.017 5.289 7.125 5.289.147 0 1.322-.209 1.506-.334.184-.126 2.46-4.849 2.46-5.142.001-.292-.477-.836-.918-1.129z"/><path fill="#233251" d="M26.627 65.233c-1.565 0-2.833-1.443-2.834-3.226V33.932l-5.111 3.938a2.344 2.344 0 0 1-1.428.496c-.817.003-1.624-.448-2.117-1.278l-3.438-5.782a3.191 3.191 0 0 1-.442-1.63c-.001-.931.397-1.849 1.124-2.41l12.024-9.264h.273L34.631 18l.001.003h1.239l-.015 1.022c-.001.053-.004.087-.005.103.012 2.703 1.935 4.889 4.313 4.894 2.375-.006 4.299-2.189 4.313-4.89-.001-.017-.004-.054-.004-.107l-.017-1.022h12.391l12.031 9.266-.494.831.495-.831c.725.561 1.122 1.481 1.121 2.412 0 .557-.142 1.129-.438 1.628l-3.442 5.786c-.493.825-1.299 1.276-2.116 1.276-.492 0-.994-.163-1.43-.5l-5.117-3.941v28.078c-.001 1.781-1.269 3.226-2.835 3.226H26.627v-.001zm-1.071-3.226c0 .674.48 1.219 1.071 1.221h27.996c.592-.001 1.07-.547 1.072-1.221V30.151l7.867 6.059a.717.717 0 0 0 .443.154.768.768 0 0 0 .657-.395l3.44-5.783a.992.992 0 0 0 .135-.504.944.944 0 0 0-.35-.75v-.001L56.305 20.01H46.189c-.388 3.395-2.938 6.018-6.026 6.019-3.089-.001-5.64-2.626-6.025-6.023l-9.193.004-11.576 8.919a.94.94 0 0 0-.348.748c0 .177.042.344.137.504l3.44 5.785a.767.767 0 0 0 .656.396.727.727 0 0 0 .443-.154l7.86-6.055v31.854h-.001z"/></svg>' },
        { id: 5, name: 'SVG 1', content: '<svg   width="35" height="35" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve"><path style="fill:#acd4f3" d="M156.237 172.059 74.98 334.968 8.727 294.706 142.061 59.211l54.859 54.859zM355.763 172.059l81.257 162.909 66.253-40.262L369.939 59.211l-43.522 76.451z"/><g style="opacity:.59"><path style="fill:#8ec1ed" d="m196.92 114.07-54.859-54.859-32.251 56.962 10.178 41.923 17.46 51.633 18.789-37.67z"/></g><g style="opacity:.59"><path style="fill:#8ec1ed" d="m315.526 114.07 54.859-54.859 32.25 56.962-10.177 41.923-17.46 51.633-18.789-37.67z"/></g><path style="fill:#acd4f3" d="M184.233 37.594h-3.976c-28.81 0-50.045 26.931-43.326 54.946l2.306 9.499 13.609 56.058 17.489 51.721h171.238l17.489-51.721 13.474-55.501 2.442-10.056c6.72-28.015-14.515-54.946-43.326-54.946H184.233zM170.336 244.98h171.238l46.583 259.4H123.753z"/><path style="fill:#8ec1ed" d="M170.337 209.82h171.242v35.164H170.337z"/><path style="fill:#cce4f7" d="m303.969 34.686-81.948 81.948-37.788-68.14V20.751c0-7.222 5.909-13.131 13.131-13.131h117.974c7.222 0 13.131 5.909 13.131 13.131v27.743l-39.592 68.14-81.947-81.948"/><path style="fill:#8ec1ed" d="m214.531 40.767 40.714 40.714s41.638-39.747 41.48-39.59h-82.591M503.273 294.706l-22.951-40.537-64.462 38.378 21.16 42.421zM8.638 294.706l22.951-40.537 64.461 38.378-21.159 42.421z"/><path d="M509.904 290.95 376.569 55.457a7.668 7.668 0 0 0-.77-1.106 53.076 53.076 0 0 0-3.176-4.507c-9.033-11.456-22.166-18.459-36.532-19.663v-9.428C336.091 9.309 326.782 0 315.339 0H197.365c-11.444 0-20.752 9.309-20.752 20.752v9.361c-14.676 1.008-28.126 8.064-37.324 19.73a52.936 52.936 0 0 0-3.772 5.477c-.027.047-.06.088-.086.136l-.267.472a51.031 51.031 0 0 0-.979 1.73L2.096 290.95a7.62 7.62 0 0 0 2.673 10.266l66.252 40.263a7.614 7.614 0 0 0 6.071.809 7.622 7.622 0 0 0 4.706-3.92l73.879-148.116 7.039 20.816V244.3l-46.462 258.731a7.616 7.616 0 0 0 7.5 8.966h264.404a7.62 7.62 0 0 0 7.5-8.966L349.195 244.3v-33.23l7.075-20.922 73.93 148.223a7.622 7.622 0 0 0 10.776 3.111l66.253-40.263a7.623 7.623 0 0 0 2.675-10.269zM191.853 20.752a5.519 5.519 0 0 1 5.512-5.512h117.974a5.518 5.518 0 0 1 5.511 5.512v25.689l-33.586 57.803-21.038-21.038 43.132-43.13a7.62 7.62 0 1 0-10.777-10.777l-4.973 4.973h-76.315l-4.972-4.973a7.62 7.62 0 1 0-10.777 10.777l7.198 7.197.014.014 35.921 35.92-20.892 20.892-31.93-57.574V20.752h-.002zm63.596 51.678-22.918-22.919h45.835L255.449 72.43zM71.858 324.154 18.999 292.03l15.486-27.352 51.608 30.936-14.235 28.54zm262.096-86.794H177.957v-19.922h155.997v19.922zm-201.09 259.4L176.71 252.6H335.2l43.847 244.159H132.864zm228.641-345.883a7.618 7.618 0 0 0-9.659 4.777l-15.738 46.542H175.804l-15.737-46.542a7.62 7.62 0 0 0-9.659-4.777 7.618 7.618 0 0 0-4.777 9.659l3.167 9.366-55.882 112.033-50.92-30.524L129.949 96.07l1.885 7.765a7.622 7.622 0 0 0 7.399 5.824 7.62 7.62 0 0 0 7.41-9.42l-2.301-9.478c-2.127-8.866-.925-17.988 3.255-25.863l.929-1.641a37.506 37.506 0 0 1 2.728-3.98c6.289-7.975 15.385-12.904 25.357-13.876v3.092c0 1.292.329 2.564.956 3.696l37.788 68.14a7.62 7.62 0 0 0 12.053 1.693l28.041-28.039 28.039 28.041a7.61 7.61 0 0 0 6.373 2.168 7.616 7.616 0 0 0 5.604-3.729l39.593-68.14a7.613 7.613 0 0 0 1.032-3.828v-3.013c9.661 1.15 18.443 6.033 24.566 13.797 7.048 8.939 9.568 20.414 6.918 31.462l-2.44 10.055a7.619 7.619 0 0 0 7.41 9.42 7.624 7.624 0 0 0 7.399-5.824l2.046-8.431 88.015 155.452-50.92 30.524-55.932-112.138 3.131-9.26a7.623 7.623 0 0 0-4.778-9.662zm78.636 173.277-14.236-28.54 51.609-30.936L493 292.031l-52.859 32.123z"/></svg>' },
    ]

    const fontOptions = [
        {
            label: 'Theme Default Font',
            value: '',
        },
        {
            label: 'Arial',
            value: 'Arial, sans-serif',
        },
        {
            label: 'Verdana',
            value: 'Verdana, sans-serif',
        },
        {
            label: 'Helvetica',
            value: 'Helvetica, sans-serif',
        },
        {
            label: 'Tahoma',
            value: 'Tahoma, sans-serif',
        },
        {
            label: 'Trebuchet MS',
            value: 'Trebuchet MS, sans-serif',
        },
        {
            label: 'Times New Roman',
            value: 'Times New Roman, serif',
        },
        {
            label: 'Georgia',
            value: 'Georgia, serif',
        },
        {
            label: 'Garamond',
            value: 'Garamond, serif',
        },
        {
            label: 'Courier New',
            value: 'Courier New, monospace',
        },
        {
            label: 'Brush Script MT',
            value: 'Brush Script MT, cursive',
        },
    ];

    const goTo = (location: string) => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app' + location);
    }

    useEffect(() => {
        getShops();
    }, []);

    const getShops = () => {
        Http.get(`/app/api/v1/shop.json`)
            .then((response) => {

                let shop = response.data.shop

                setLegacy(shop.legacy);
                setFree(shop.free);
                getStyle();
                Menu.loadMenu(shop);

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    const getStyle = () => {
        Http.get(`/app/api/v1/styles`).then(response => {
            form.withData(response.data);
            setFormInitialized(true);

            let icon = response.data.icon;
            if(icon){
              let tmpSvg =  svgs.find(svg => svg.id === icon);
              if(tmpSvg){
                  setSelectedSvg(tmpSvg);
              }
            }
        });
    }
    const selectSvg = (svg : ChartIcon | null) => {
        if(legacy == 1 || free == 1) {
            return;
        }

        setImageURL(null)
       // this.showCustomUpload = false;

        if(!svg){
          setSelectedSvg(null)
            form.handleRadio('icon',null);
            return;
        }
        setSelectedSvg(svg);
        form.handleRadio('icon', svg.id);
        setTimeout(function() { setDropdownOpen(false)}, 1000);
    }


    const saveSettings = () => {
        setError(false);
        setLoading(true);
        let formError: ResponseErrors = {} ;

        if (form.fields.btnTextEditable && !form.fields.btnText.trim()){
            formError.btnText = ["Link/Button field is required."];
        }

        if (form.fields.triggerEditable && !form.fields.triggerFontSize){
            formError.triggerFontSize = ["Font Size field is required."];
        }

        if (form.fields.triggerEditable && !form.fields.triggerColor){
            formError.triggerColor = ["Text Color field is required."];
        }

        if (form.fields.tableHeaderEditable && !form.fields.headerFontSize){
            formError.headerFontSize = ["Font Size field is required."];
        }

        if (form.fields.tableHeaderEditable && !form.fields.headerBorderColor){
            formError.headerBorderColor = ["Border color field is required."];
        }

        if (form.fields.tableHeaderEditable && !form.fields.headerBorderWidth){
            alert('3423');
            formError.headerBorderWidth = ["Border width field is required."];
        }

        if (form.fields.tableHeaderEditable && !form.fields.headerTextColor){
            formError.headerTextColor = ["Text color field is required."];
        }

        if (form.fields.tableHeaderEditable && !form.fields.headerBackgroundColor){
            formError.headerBackgroundColor = ["Background color field is required."];
        }

        if (form.fields.tableBodyEditable && !form.fields.bodyFontSize){
            formError.bodyFontSize = ["Font size field is required."];
        }


        if (form.fields.tableBodyEditable && !form.fields.bodyBackgroundColor){
            formError.bodyBackgroundColor = ["Background color field is required."];
        }


        if (form.fields.tableBodyEditable && !form.fields.bodyTextColor){
            formError.bodyTextColor = ["Text color field is required."];
        }


        if (form.fields.tableBodyEditable && !form.fields.bodyBorderWidth){
            formError.bodyBorderWidth = ["Width field is required."];
        }


        if (form.fields.tableBodyEditable && !form.fields.bodyBorderColor){
            formError.bodyBorderColor = ["Border color field is required."];
        }


        if (Object.keys(formError).length > 0) {
            form.setErrors(formError);
            setLoading(false);
            return;
        }


        Http.post(`/app/api/v1/styles`, {
            tableBodyEditable: form.fields.tableBodyEditable,
            color: form.fields.color,
            customCss: form.fields.customCss,
            bodyFont: form.fields.bodyFont,
            bodyFontSize: form.fields.bodyFontSize,
            bodyBorderColor: form.fields.bodyBorderColor,
            bodyBorderWidth: form.fields.bodyBorderWidth,
            bodyTextColor: form.fields.bodyTextColor,
            bodyBackgroundColor: form.fields.bodyBackgroundColor,
            tableHeaderEditable: form.fields.tableHeaderEditable,
            headerFont: form.fields.headerFont,
            headerFontSize: form.fields.headerFontSize,
            headerBorderColor: form.fields.headerBorderColor,
            headerBorderWidth: form.fields.headerBorderWidth,
            headerTextColor: form.fields.headerTextColor,
            headerBackgroundColor: form.fields.headerBackgroundColor,
            uploadedIcon: form.fields.imageUrl ? form.fields.imageUrl : null,
            icon: form.fields.icon,
            btnText: form.fields.btnTextEditable ? form.fields.btnText : null,
            triggerEditable: form.fields.triggerEditable,
            triggerFont: form.fields.triggerFont,
            triggerFontSize: form.fields.triggerFontSize,
            triggerColor: form.fields.triggerColor,
            underlineTrigger: form.fields.underlineTrigger,
            displayEditable: form.fields.displayEditable,
            displayOption: form.fields.displayOption,
            collapseBorder: form.fields.collapseBorder,
            tableAlignment: form.fields.tableAlignment,
            allowUnitConversion: form.fields.allowUnitConversion,
            unit: form.fields.unit,
        }).then(res => {
                setLoading(false);
                form.withData(res.data);;
                Alert.success('Style settings saved');
        }).catch(e => {
                setLoading(false);
                setError(true);
                 window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
    const discard = () => {
        form.reset();
    }

    const goToWizard = () => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app/wizard/4?settings=1');
    }


    return (
        <Page
            backAction={{content: 'Home', onAction() {goTo('')}}}
            title="Design Settings"
            secondaryActions={[
                {
                    content: 'Enable/Disable Pre-Styled Charts',
                    accessibilityLabel: 'Enable/Disable Pre-Styled Charts',
                    onAction: () => goToWizard(),
                }
            ]}
            >
            {form.isDirty &&
                <ContextualSaveBar
                    message={"Unsaved changes"}
                    saveAction={{
                        onAction: () => saveSettings(),
                        loading: loading,
                        disabled: loading  || (legacy == 1 || free == 1),
                    }}
                    discardAction={{
                        onAction: () => discard(),
                    }}
                />
            }
            {((legacy == 1 || free == 1) && showBilling) &&
                <Layout>
                    <Layout.Section>
                        <div style={{paddingBottom: '20px', marginBottom: '20px'}}>
                            <Banner
                                title="Upgrade to Paid plan to fully customise your size charts"
                                tone="warning"
                                action={{content: 'Go to billing', onAction() {
                                        goTo('/wizard/2?upgrade=1');
                                    }}}
                            >
                                <p>
                                    This feature is only available on the premium plan. <br/>
                                    Upgrade to the paid plan to fully customise your size charts. Including table headers and body, trigger icon and trigger design.
                                </p>
                            </Banner>
                        </div>
                    </Layout.Section>
                </Layout>
            }

            {error &&
                <Layout>
                    <Layout.Section>
                            <CriticalError  onDismiss={() => {setError(false)}}  showAlert={error} title={'Failed to update design settings'} />
                    </Layout.Section>
                </Layout>
            }

            <Layout>
                <Layout.Section>
                    <Card>
                        <p> Maximize the effectiveness of your size guide with customizable settings for table headers
                            and bodies.
                            Adjust font size, background and font colors, and select from a range of
                            web-safe font families. Fine-tune your design with options to modify border widths and
                            colors.
                        </p>
                        <p>
                            <br/>
                            Please note that this feature is not supported by Shop App and only applies to the online
                            store.
                        </p>
                    </Card>
                </Layout.Section>
                <div className={(legacy == 1 || free == 1) ? 'billing-muted' : ''}>
                    <Layout.AnnotatedSection
                        id="storeDetails"
                        title="Link/Button Design"
                        description="Shopify and your customers will use this information to contact you."
                    >
                        <Card>
                            <FormLayout>
                                <div>

                                    <div style={{width: "100%"}}>
                                        Link icon
                                    </div>
                                    <div className="dropdown" onClick={() => setDropdownOpen(!dropdownOpen)}>
                                        <div className="dropdown-selected">
                                            {selectedSvg && !imageUrl ? (
                                                <div dangerouslySetInnerHTML={{__html: selectedSvg.content}}></div>
                                            ) : !selectedSvg && !imageUrl ? (
                                                <div>None</div>
                                            ) : (
                                                imageUrl && <img className="icon-image-preview" src={imageUrl} height="70"
                                                                 alt="Selected"/>
                                            )}
                                            <span className={`chevron ${dropdownOpen ? 'up' : ''}`}
                                                  ></span>

                                            {dropdownOpen && (
                                                <div className="dropdown-content">
                                                    <div className="dropdown-item" onClick={() => selectSvg(null)}>
                                                        <div>None</div>
                                                    </div>
                                                    {svgs.map((svg) => (
                                                        <div className="dropdown-item" key={svg.id}
                                                             onClick={() => selectSvg(svg)}>
                                                            <div dangerouslySetInnerHTML={{__html: svg.content}}></div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{width: "100%", display:"none"}}>
                                        <Button variant="plain">Upload custom icon</Button>
                                    </div>
                                    <div className="Polaris-Choice__Descriptions mt-10">
                                        <div className="Polaris-Choice__HelpText">
                                   <span className="Polaris-Text--root Polaris-Text--subdued">
                                       When selected, an icon will appear next to the size guide trigger link
                               </span>
                                        </div>
                                    </div>
                                </div>
                                <Divider borderColor="border"/>
                                <Text variant="headingMd" as="h6">
                                    Button/Link text
                                </Text>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div style={{flex: 1, marginRight: '10px'}}>
                                        <Checkbox
                                            helpText="Enable to override default text"
                                            label="Use Custom link/button text "
                                            checked={form.fields.btnTextEditable}
                                            onChange={form.handleChange('btnTextEditable')}
                                            disabled={(legacy == 1 || free == 1)}
                                        />
                                    </div>
                                    <div style={{flex: 1}}>
                                        <TextField
                                            value={form.fields.btnText}
                                            type="text"
                                            label="Link/Button text"
                                            onChange={form.handleChange('btnText')}
                                            autoComplete="off"
                                            error={form.getError('btnText')}
                                            disabled={!form.fields.btnTextEditable  || (legacy == 1 || free == 1)}
                                        />
                                    </div>
                                </div>
                            </FormLayout>
                        </Card>
                        <div style={{paddingTop: "20px"}}>&nbsp;</div>
                        <Card>
                            <FormLayout>
                                <Checkbox
                                    helpText="When enabled, the link or button that triggers the size guide will use
                                    the setting below instead of defaulting to your themes style"
                                    label=" Enable custom trigger link/button styles "
                                    checked={form.fields.triggerEditable}
                                    disabled={(legacy == 1 || free == 1)}
                                    onChange={form.handleChange('triggerEditable')}
                                />
                                <Divider borderColor="border"/>

                                <Text variant="headingSm" as="h6">
                                    FONT
                                </Text>
                                <FormLayout.Group>
                                    <Select
                                        label="Font family"
                                        options={fontOptions}
                                        onChange={form.handleChange('triggerFont')}
                                        value={form.fields.triggerFont}
                                        disabled={!form.fields.triggerEditable}
                                    />
                                    <TextField
                                        type="number"
                                        prefix="px"
                                        label="Font Size"
                                        autoComplete="off"
                                        onChange={form.handleChange('triggerFontSize')}
                                        value={form.fields.triggerFontSize}
                                        error={form.getError('triggerFontSize')}
                                        disabled={!form.fields.triggerEditable}
                                    />
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    COLOR AND DECORATION
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>

                                            <TextField
                                                type="text"
                                                label="Text Color"
                                                value={form.fields.triggerColor}
                                                onChange={form.handleChange('triggerColor')}
                                                disabled={!form.fields.triggerEditable}
                                                autoComplete="off"
                                                error={form.getError('triggerColor')}
                                                onFocus={() => {
                                                    setShowTriggerColorPicker(true);
                                                }}
                                            />
                                            {showTriggerColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.triggerColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('triggerColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div style={{flex: 1}}>
                                            <Checkbox
                                                label="Underline trigger link "
                                                checked={form.fields.underlineTrigger}
                                                disabled={!form.fields.triggerEditable}
                                                onChange={form.handleChange('underlineTrigger')}
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="storeDetails"
                        title="Display Options, Table "
                        description="Change your display option and overall table settings "
                    >
                        <Card>
                            <FormLayout>
                                <Text variant="headingMd" as="h6">
                                    DISPLAY OPTION
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <Checkbox
                                                helpText="Enable to override display option specified in the 'App Block' or HTML widget"
                                                label="Override display option "
                                                checked={form.fields.displayEditable}
                                                onChange={form.handleChange('displayEditable')}
                                                disabled={(legacy == 1 || free == 1)}
                                            />

                                        </div>
                                        <div style={{flex: 1}}>

                                            <LegacyStack vertical>
                                                <RadioButton
                                                    label="Link"
                                                    checked={form.fields.displayOption === 'link'}
                                                    name="displayOption"
                                                    value={'link'}
                                                    onChange={() => form.handleRadio('displayOption', 'link')}
                                                    disabled={!form.fields.displayEditable || (legacy == 1 || free == 1)}
                                                />
                                                <RadioButton
                                                    label="Button"
                                                    checked={form.fields.displayOption === 'button'}
                                                    name="displayOption"
                                                    value={'button'}
                                                    onChange={() => form.handleRadio('displayOption', 'button')}
                                                    disabled={!form.fields.displayEditable}
                                                />
                                                <RadioButton
                                                    label="Inline"
                                                    checked={form.fields.displayOption === 'inline'}
                                                    name="displayOption"
                                                    value={'button'}
                                                    disabled={!form.fields.displayEditable}
                                                    onChange={() => form.handleRadio('displayOption', 'inline')}
                                                />
                                                <RadioButton
                                                    label="Floating/Sticky"
                                                    checked={form.fields.displayOption === 'sticky'}
                                                    name="displayOption"
                                                    value={'button'}
                                                    disabled={!form.fields.displayEditable}
                                                    onChange={() => form.handleRadio('displayOption', 'sticky')}
                                                />
                                            </LegacyStack>
                                        </div>
                                    </div>
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    ALIGNMENT & BORDER
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <Select
                                                label="Table alignment"
                                                options={[
                                                    {
                                                        label: 'Default',
                                                        value: '',
                                                    },
                                                    {
                                                        label: 'Left',
                                                        value: 'left',
                                                    },
                                                    {
                                                        label: 'Center',
                                                        value: 'center',
                                                    },
                                                    {
                                                        label: 'Right',
                                                        value: 'right',
                                                    }
                                                ]}
                                                onChange={form.handleChange('tableAlignment')}
                                                value={form.fields.tableAlignment}
                                                disabled={(legacy == 1 || free == 1)}
                                            />
                                        </div>
                                        <div style={{flex: 1}}>
                                            <Checkbox
                                                helpText="Enabling this feature eliminates the gap between table cells caused by themes such as Dawn"
                                                label="Collapse table border "
                                                checked={form.fields.collapseBorder}
                                                onChange={form.handleChange('collapseBorder')}
                                                disabled={(legacy == 1 || free == 1)}
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    MEASUREMENT UNIT CONVERSION
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <Checkbox
                                                label="Enable automatic unit conversion"
                                                checked={form.fields.allowUnitConversion}
                                                onChange={form.handleChange('allowUnitConversion')}
                                                disabled={(legacy == 1 || free == 1)}
                                            />
                                        </div>
                                        <div style={{flex: 1}}>
                                            <Select
                                                label=" Default Unit"
                                                options={ [
                                                    {
                                                        label: 'CM',
                                                        value: 'CM',
                                                    },
                                                    {
                                                        label: 'Inches',
                                                        value: 'IN',
                                                    }
                                                ]}
                                                onChange={form.handleChange('unit')}
                                                value={form.fields.unit}
                                                disabled={!form.fields.allowUnitConversion}
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                            <div className="mt-10">
                            </div>

                            <div className="Polaris-Choice__Descriptions">
                                <div className="Polaris-Choice__HelpText">
                                   <span className="Polaris-Text--root Polaris-Text--subdued">
    This feature converts centimeters to inches and vice versa for size charts on the store front.
    These conversions are approximate and may not be exact due to rounding and formatting variations. It should be used as a general guide, understanding that it might not provide exact measurements in all cases.

                               </span>
                                </div>
                            </div>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="storeDetails"
                        title="Table Header Design "
                        description="Customize your table headers with ease. Choose colors, fonts, and borders to match your brand and enhance the look your size guides. "
                    >
                        <Card>
                            <FormLayout>
                                <Checkbox
                                    helpText="When enabled, the size guide table header of your size guide will use the setting below instead of defaulting to your themes style"
                                    label="Enable custom table header styles"
                                    checked={form.fields.tableHeaderEditable}
                                    onChange={form.handleChange('tableHeaderEditable')}
                                    disabled={(legacy == 1 || free == 1)}
                                />
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    FONT
                                </Text>
                                <FormLayout.Group>
                                    <Select
                                        label="Font family"
                                        options={fontOptions}
                                        onChange={form.handleChange('headerFont')}
                                        value={form.fields.headerFont}
                                        disabled={!form.fields.tableHeaderEditable}
                                    />
                                    <TextField
                                        type="number"
                                        prefix="px"
                                        label="Font Size"
                                        onChange={form.handleChange('headerFontSize')}
                                        value={form.fields.headerFontSize}
                                        autoComplete="off"
                                        error={form.getError('headerFontSize')}
                                        disabled={!form.fields.tableHeaderEditable}
                                    />
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    BORDER
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <TextField
                                                type="text"
                                                label="Border Color"
                                                onChange={form.handleChange('headerBorderColor')}
                                                value={form.fields.headerBorderColor}
                                                autoComplete="off"
                                                disabled={!form.fields.tableHeaderEditable}
                                                error={form.getError('headerBorderColor')}
                                                onFocus={() => {
                                                    setShowHeaderBorderColorPicker(true);
                                                }}
                                            />
                                            {showHeaderBorderColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.headerBorderColor}
                                                         onChangeComplete={( color: ColorResult) => {
                                                             form.handleRadio('headerBorderColor', color.hex)
                                                         }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div style={{flex: 1}}>
                                            <TextField
                                                value={form.fields.headerBorderWidth}
                                                onChange={form.handleChange('headerBorderWidth')}
                                                type="number"
                                                label="Border Width"
                                                autoComplete="off"
                                                disabled={!form.fields.tableHeaderEditable}
                                                error={form.getError('headerBorderWidth')}
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group> <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    TEXT AND BACKGROUND
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <TextField
                                                type="text"
                                                label="Text Color"
                                                onChange={form.handleChange('headerTextColor')}
                                                value={form.fields.headerTextColor}
                                                autoComplete="off"
                                                disabled={!form.fields.tableHeaderEditable}
                                                onFocus={() => {
                                                    setShowHeaderTextColorPicker(true);
                                                }}
                                                error={form.getError('headerTextColor')}
                                            />
                                            {showHeaderTextColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.headerTextColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('headerTextColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div style={{flex: 1}}>
                                            <TextField
                                                type="text"
                                                label="Background Color"
                                                onChange={form.handleChange('headerBackgroundColor')}
                                                value={form.fields.headerBackgroundColor}
                                                autoComplete="off"
                                                disabled={!form.fields.tableHeaderEditable}
                                                onFocus={() => {
                                                    setShowHeaderBackgroundColorPicker(true);
                                                }}
                                                error={form.getError('headerBackgroundColor')}
                                            />
                                            {showHeaderBackgroundColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.headerBackgroundColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('headerBackgroundColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="storeDetails"
                        title="Table Body Design "
                        description="Customize your table body with ease. Choose colors, fonts, and borders to match your brand and enhance the look your size guides. "
                    >
                        <Card>
                            <FormLayout>
                                <Checkbox
                                    helpText="When enabled, the size guide table body of your size guide will use the setting below instead of defaulting to your themes style"
                                    label="Enable custom table body styles "
                                    checked={form.fields.tableBodyEditable}
                                    onChange={form.handleChange('tableBodyEditable')}
                                    disabled={(legacy == 1 || free == 1)}
                                />
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    FONT
                                </Text>
                                <FormLayout.Group>
                                    <Select
                                        label="Font family"
                                        options={fontOptions}
                                        onChange={form.handleChange('bodyFont')}
                                        value={form.fields.bodyFont}
                                        disabled={!form.fields.tableBodyEditable}
                                    />
                                    <TextField
                                        type="number"
                                        label="Font Size"
                                        onChange={form.handleChange('bodyFontSize')}
                                        value={form.fields.bodyFontSize}
                                        disabled={!form.fields.tableBodyEditable}
                                        autoComplete="off"
                                        error={form.getError('bodyFontSize')}
                                    />
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    BORDER
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <TextField
                                                type="text"
                                                label="Border Color"
                                                onChange={form.handleChange('bodyBorderColor')}
                                                value={form.fields.bodyBorderColor}
                                                disabled={!form.fields.tableBodyEditable}
                                                autoComplete="off"
                                                onFocus={() => {
                                                    setShowBodyBorderColorPicker(true);
                                                }}
                                                error={form.getError('bodyBorderColor')}
                                            />
                                            {showBodyBorderColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.bodyBorderColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('bodyBorderColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div style={{flex: 1}}>
                                            <TextField
                                                type="number"
                                                label="Border Width"
                                                onChange={form.handleChange('bodyBorderWidth')}
                                                value={form.fields.bodyBorderWidth}
                                                disabled={!form.fields.tableBodyEditable}
                                                autoComplete="off"
                                                error={form.getError('bodyBorderWidth')}
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group> <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    TEXT AND BACKGROUND
                                </Text>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <TextField
                                                type="text"
                                                label="Text Color"
                                                onChange={form.handleChange('bodyTextColor')}
                                                value={form.fields.bodyTextColor}
                                                disabled={!form.fields.tableBodyEditable}
                                                autoComplete="off"
                                                onFocus={() => {
                                                    setShowBodyTextColorPicker(true);
                                                }}
                                                error={form.getError('bodyTextColor')}
                                            />
                                            {showBodyTextColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.bodyTextColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('bodyTextColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div style={{flex: 1}}>
                                            <TextField
                                                type="text"
                                                label="Background Color"
                                                onChange={form.handleChange('bodyBackgroundColor')}
                                                value={form.fields.bodyBackgroundColor}
                                                disabled={!form.fields.tableBodyEditable}
                                                autoComplete="off"
                                                onFocus={() => {
                                                    setShowBodyBackgroundColorPicker(true);
                                                }}
                                                error={form.getError('bodyBackgroundColor')}
                                            />
                                            {showBodyBackgroundColorPicker &&
                                                <div className="mt-10">
                                                    <SketchPicker
                                                        color={form.fields.bodyBackgroundColor}
                                                        onChangeComplete={( color: ColorResult) => {
                                                            form.handleRadio('bodyBackgroundColor', color.hex)
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                </div>
                <div>
                    <br/>
                </div>
            </Layout>
        </Page>
    );
}

export default Design;
